export const UPDATE_PAGE_NUMBER = "UPDATE_PAGE_NUMBER";
export const UPDATE_PAGE_SIZE = "UPDATE_PAGE_SIZE";
export const UPDATE_PAGE_NUMBER_AND_SIZE = "UPDATE_PAGE_NUMBER_AND_SIZE";
export const RESET_PAGE_NUMBER_AND_SIZE = "RESET_PAGE_NUMBER_AND_SIZE";
